import React from 'react';
import { ChatBubbleLeftRightIcon, EnvelopeIcon, QuestionMarkCircleIcon, BookOpenIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';
import Faq from './faq';
import { SupportFAQ } from './support-faq-constant';
import { useGetUser } from '../../hooks/api-hooks';

const SupportPage = () => {
  const user = useGetUser();

  const openCrispChat = () => {
    if (window.$crisp) {
      window.$crisp.push(['do', 'chat:open']);
      window.$crisp.push(["set", "user:email", user.data?.email]);
    }
  };

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl">
        <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold mb-4">
          Support Center
        </h1>
        <p className="text-xl text-gray-500 mb-12">
          We're here to help you with any questions or issues you may have. Choose one of the options below to get in touch with our support team.
        </p>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Live Chat */}
          <div className="bg-white overflow-hidden shadow rounded-lg flex flex-col">
            <div className="px-4 py-5 sm:p-6 flex-grow">
              <ChatBubbleLeftRightIcon className="h-12 w-12 text-indigo-600 mb-4" />
              <h2 className="text-lg font-medium text-gray-900 mb-2">Live Chat</h2>
              <p className="text-base text-gray-500 mb-4">
                Chat with our support team in real-time for immediate assistance.
              </p>
            </div>
            <div className="px-4 py-4 sm:px-6 bg-gray-50">
              <button
                className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                onClick={() => openCrispChat()}
              >
                Anonymous Chat
              </button>
            </div>
          </div>

          {/* Discord Support */}
          <div className="bg-white overflow-hidden shadow rounded-lg flex flex-col">
            <div className="px-4 py-5 sm:p-6 flex-grow">
              <RocketLaunchIcon className="h-12 w-12 text-indigo-600 mb-4" />
              <h2 className="text-lg font-medium text-gray-900 mb-2">Discord Support</h2>
              <p className="text-base text-gray-500 mb-4">
                Join our Discord community for support and discussion with other users.
              </p>
            </div>
            <div className="px-4 py-4 sm:px-6 bg-gray-50">
              <a
                href="https://discord.gg/GYQrZPgpwN"
                className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
              >
                Join Discord
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className='max-w-3xl mt-20'>
        <Faq questions={SupportFAQ}/>
      </div>
    </div>
  );
};

export default SupportPage;